/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingCancellationDisputeDto } from './BookingCancellationDisputeDto';
import type { BookingClientDto } from './BookingClientDto';
import type { BookingLocationDto } from './BookingLocationDto';
import type { BookingPackageDto } from './BookingPackageDto';
import type { BookingRefundDto } from './BookingRefundDto';
import type { BookingServiceDto } from './BookingServiceDto';
import type { BookingSessionItemDto } from './BookingSessionItemDto';
export type BookingDetailResponseDto = {
    /**
     * Booking UUID
     */
    bookingId: string;
    /**
     * Booking number
     */
    bookingNumber?: string | null;
    /**
     * Booking type
     */
    bookingType: string;
    /**
     * Session type
     */
    sessionType?: string | null;
    /**
     * Booking creation date
     */
    createdAt?: Record<string, any> | null;
    /**
     * Mode
     */
    mode?: string | null;
    /**
     * Booking status
     */
    status: BookingDetailResponseDto.status | null;
    /**
     * Total amount
     */
    totalAmount?: number | null;
    /**
     * Payment transaction ID
     */
    transactionId?: string | null;
    /**
     * Payment status
     */
    paymentStatus?: string | null;
    /**
     * Package validity start date
     */
    packageValidityStart?: string | null;
    /**
     * Package validity end date
     */
    packageValidityEnd?: string | null;
    /**
     * Sessions used count
     */
    sessionsUsed?: number | null;
    /**
     * Sessions remaining count
     */
    sessionsRemaining?: number | null;
    package?: BookingPackageDto;
    service: BookingServiceDto;
    client: BookingClientDto;
    location?: BookingLocationDto;
    /**
     * Total sessions
     */
    totalSessions: number;
    /**
     * Completed sessions
     */
    completedSessions: number;
    /**
     * Session progress
     */
    sessionProgress: string;
    /**
     * All sessions in the booking
     */
    sessions: Array<BookingSessionItemDto>;
    cancellationRequest?: BookingCancellationDisputeDto;
    refund?: BookingRefundDto | null;
};
export namespace BookingDetailResponseDto {
    /**
     * Booking status
     */
    export enum status {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
}

